(function() {
  class $6acb140af4ce141d$var$ProductGrid extends HTMLElement {
    constructor() {
      super();
      this.gridItems = this.querySelectorAll("[data-grid-item]");
    }
    connectedCallback() {
      this.setItemHeight();
      this.boundResizeHandler = this.handleResize.bind(this);
      window.addEventListener("resize", this.boundResizeHandler);
    }
    disconnectedCallback() {
      if (this.boundResizeHandler) window.removeEventListener("resize", this.boundResizeHandler);
    }
    handleResize() {
      this.setItemHeight();
    }
    setItemHeight() {
      const firstItem = this.gridItems[0];
      if (!firstItem) return;
      const media = firstItem.querySelector("img, video");
      if (!media) return;
      const mediaHeight = media.offsetHeight;
      this.style.setProperty("--grid-item-height", `${mediaHeight}px`);
    }
  }
  if (!customElements.get("product-grid")) customElements.define("product-grid", $6acb140af4ce141d$var$ProductGrid);
})();